import type {TokenClaimsSerializer} from "@/generated/DjangoTypes";
import CompanyDashboard from "@/pages/CompanyDashboard";
import useTokenStore from "@/store/token";
import {fetchCompany} from "@/utils/loaderUtils";
import {createFileRoute, redirect} from "@tanstack/react-router";
import {zodValidator} from "@tanstack/zod-adapter";
import {jwtDecode} from "jwt-decode";
import {z} from "zod";

export const Route = createFileRoute("/_authenticated/_company/company/$companyId/dashboard")({
  component: CompanyDashboard,
  params: {
    parse: raw => ({companyId: +raw.companyId}),
    stringify: params => ({companyId: params.companyId?.toString()}),
  },
  validateSearch: zodValidator(
    z.object({
      from: z.string().optional(),
    }),
  ),
  loader: async ({params}) => {
    const token = useTokenStore.getState().access;

    if (!token) {
      throw redirect({to: "/login", replace: true});
    }

    const claims = jwtDecode<TokenClaimsSerializer>(token);
    const isAdmin = claims.access_level === "COMPANY_ADMIN" || claims.access_level === "INFLUENCER_ADMIN";
    const isAgency = claims.access_level === "AGENCY";

    if (!isAdmin && !isAgency) {
      return;
    }

    const company = await fetchCompany(params.companyId);

    if (company.agency?.multiple_brands) {
      throw redirect({
        to: "/agency/$agencyId/subbrand/$companyId/dashboard",
        params: {agencyId: company.agency.id, companyId: company.id},
        replace: true,
      });
    }

    return;
  },
});
